import React from 'react';
import { motion } from 'framer-motion';
const STEPS = [{
  n: '1',
  title: 'Purchase',
  body: 'Grab GPS Journal from the Notion Marketplace in a couple of clicks.'
}, {
  n: '2',
  title: 'Duplicate',
  body: 'Use your link to duplicate the template straight into your Notion workspace.'
}, {
  n: '3',
  title: 'Start living aligned',
  body: 'Set your goal, tick your habits, and begin your 5-minute daily journal.'
}];
export function Steps() {
  return <section className="w-full bg-neutral-50 py-24" data-id="element-120" data-mp="pnvfzlz3isw4">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-121" data-mp="plipgkf9va7g">
        <div className="mx-auto max-w-2xl text-center" data-id="element-122" data-mp="bp5ja7g6uv8a">
          <h2 className="text-3xl font-extrabold tracking-tight text-ink sm:text-4xl" data-id="element-123" data-mp="fpfkz7wy6zhc">
            Your GPS Journal ready in 1, 2, 3.
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-124" data-mp="2636dug4pgw2k">
            Get started in minutes, even if you’re a Notion novice.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-125" data-mp="1qbc7bv0wkt7l">
          {STEPS.map((s, i) => <motion.div key={s.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.1
        }} className="rounded-2xl border border-line bg-white p-8 text-center" data-id="element-126" data-mp="1lc91w9h0gkz3" data-mpi={i}>
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-ink text-lg font-bold text-white" data-id="element-127" data-mp="17czxe7263fay">
                {s.n}
              </span>
              <h3 className="mt-5 text-lg font-bold text-ink" data-id="element-128" data-mp="1haxhqjgworya">{s.title}</h3>
              <p className="mt-2 leading-relaxed text-muted" data-id="element-129" data-mp="1cbucaxx0kjps">{s.body}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}